import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppGrammarTabComponent } from './grammar.component';

const routes: Routes = [{ path: '', component: AppGrammarTabComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppGrammarTabRoutingModule { }
